import logo from "./logo.svg";
import "./App.css";
// import Navbar from "./components/Navbar";
import Home from "./components/Home";
function App() {
  return <Home />;
}

export default App;
